// export control from './control'
// export formControl from './formControl'
// export itemsMixins from './itemsMixins'
// export layout from './layout'
// export view from './view'
// export layoutView from './layoutView'
// export form from './form'
// export list from './list'
// export oneToMany from './oneToMany'
// // export mobileBase from './mobileBase'
// export mobileLayoutView from './mobileLayoutView'
// export pcLayoutView from './pcLayoutView'

// export tabControl from './tabControl'
// export text from './text'
// export tree from './tree'
// export buttonBar from "./buttonBar"

// export disposeIdea from "./compnents/flow/disposeIdea"
// export flowInfo from "./compnents/flow/flowInfo"
// export formCommentBox from "./compnents/flow/formCommentBox"
// export tabPanelSetting from "./compnents/homeTabPanel/tabPanelSetting"
// export tabPanelTabSetting from "./compnents/homeTabPanel/tabPanelTabSetting"
// export card from './card'
// export cardList from './cardList'
// export chart from './chart'
// export convenientMenu from './convenientMenu'
// export dataResult from './dataResult'
// export fileEncrypt from './fileEncrypt'
// // export vDrag from './vd'
// export formulaAuditStateMixin from './formulaAuditStateMixin'
// export virtualTreeMixin from './virtualTreeMixin'

let mixins = {};
let map = {};
const defineProperty = function (obj, key, get) {
  Object.defineProperty(obj, key, {
    get() {
      if (!map[key]) {
        map[key] = get();
      }
      return map[key];
    },
    enumerable: true,
    configurable: true
  });
};

function addAsync(obj, key, getter) {
  defineProperty(obj, key, () => {
    const _getter = function () {
      if (!_getter.options) {
        return getter().then((module) => {
          module = dsf.getEsModule(module);
          Object.defineProperty(_getter, "options", {
            value: module,
            enumerable: true,
            configurable: true
          });
          return _getter.options;
        });
      } else {
        return Promise.resolve(_getter.options);
      }
    };
    return _getter;
  });
}

defineProperty(mixins, "control", () => {
  return require("./control").default;
});

defineProperty(mixins, "formControl", () => {
  return require("./formControl").default;
});
defineProperty(mixins, "itemsMixins", () => {
  return require("./itemsMixins").default;
});
defineProperty(mixins, "layout", () => {
  return require("./layout").default;
});
defineProperty(mixins, "view", () => {
  return require("./view").default;
});
defineProperty(mixins, "layoutView", () => {
  return require("./layoutView").default;
});
defineProperty(mixins, "form", () => {
  return require("./form").default;
});
defineProperty(mixins, "list", () => {
  return require("./list").default;
});
defineProperty(mixins, "oneToMany", () => {
  return require("./oneToMany").default;
});
defineProperty(mixins, "mobileLayoutView", () => {
  return require("./mobileLayoutView").default;
});
defineProperty(mixins, "pcLayoutView", () => {
  return require("./pcLayoutView").default;
});
defineProperty(mixins, "tabControl", () => {
  return require("./tabControl").default;
});
defineProperty(mixins, "text", () => {
  return require("./text").default;
});
defineProperty(mixins, "tree", () => {
  return require("./tree").default;
});
defineProperty(mixins, "buttonBar", () => {
  return require("./buttonBar").default;
});
defineProperty(mixins, "disposeIdea", () => {
  return require("./compnents/flow/disposeIdea").default;
});
defineProperty(mixins, "flowInfo", () => {
  return require("./compnents/flow/flowInfo").default;
});
defineProperty(mixins, "formCommentBox", () => {
  return require("./compnents/flow/formCommentBox").default;
});
defineProperty(mixins, "tabPanelSetting", () => {
  return require("./compnents/homeTabPanel/tabPanelSetting").default;
});
defineProperty(mixins, "tabPanelTabSetting", () => {
  return require("./compnents/homeTabPanel/tabPanelTabSetting").default;
});
defineProperty(mixins, "card", () => {
  return require("./card").default;
});
defineProperty(mixins, "cardList", () => {
  return require("./cardList").default;
});
defineProperty(mixins, "chart", () => {
  return require("./chart").default;
});
defineProperty(mixins, "convenientMenu", () => {
  return require("./convenientMenu").default;
});

defineProperty(mixins, "dataResult", () => {
  return require("./dataResult").default;
});
defineProperty(mixins, "fileEncrypt", () => {
  return require("./fileEncrypt").default;
});
defineProperty(mixins, "formulaAuditStateMixin", () => {
  return require("./formulaAuditStateMixin").default;
});
defineProperty(mixins, "virtualTreeMixin", () => {
  return require("./virtualTreeMixin").default;
});
defineProperty(mixins, "formFormulaAuditMixinControl", () => {
  return require("./formFormulaAuditMixinControl").default;
});
//智应用卡片
defineProperty(mixins, "smartCard", () => {
  return require("./smartCard").default;
});
//智应用卡片
addAsync(mixins, "smartCard", () =>
  import(/*webpackChunkName:"platform_mixin_smartcard"*/ "./smartCard")
);

export default mixins;
